var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusEdited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 16,
    viewBox: "0 0 71 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 16,
    rx: 2,
    fill: "#F68D0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.24 10.91V8.98H21.62V7.91H18.24V6.09H22.05V5H16.94V12H22.19V10.91H18.24ZM23.4892 12H26.5492C28.8192 12 30.3692 10.6 30.3692 8.5C30.3692 6.4 28.8192 5 26.5492 5H23.4892V12ZM24.7892 10.9V6.1H26.4892C28.0492 6.1 29.0592 7.05 29.0592 8.5C29.0592 9.95 28.0492 10.9 26.4892 10.9H24.7892ZM31.6009 12H32.9009V5H31.6009V12ZM36.0643 12H37.3643V6.1H39.6843V5H33.7443V6.1H36.0643V12ZM41.8099 10.91V8.98H45.1899V7.91H41.8099V6.09H45.6199V5H40.5099V12H45.7599V10.91H41.8099ZM47.0591 12H50.1191C52.3891 12 53.9391 10.6 53.9391 8.5C53.9391 6.4 52.3891 5 50.1191 5H47.0591V12ZM48.3591 10.9V6.1H50.0591C51.6191 6.1 52.6291 7.05 52.6291 8.5C52.6291 9.95 51.6191 10.9 50.0591 10.9H48.3591Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusEdited);
export default __webpack_public_path__ + "static/media/Status-EDITED.88f86150.svg";
export { ForwardRef as ReactComponent };